const toastErrors = {
  'not-found': 'Penugasan tidak ditemukan',
  'failed-to-get': 'Gagal mengambil data penugasan',
  'failed-to-save': 'Gagal menyimpan data penugasan',
  'failed-to-bulk-delete': 'Gagal dihapus. Ada status penugasan selain Draf.',
  'failed-to-delete-with-vendor': 'Gagal hapus. Terdapat penugasan dengan permintaan pengiriman.',
  'failed-to-canceled': 'Gagal ubah status. Terdapat pengiriman dari permintaan pengiriman.',
  'failed-to-complete': 'Gagal melakukan perubahan status aktivitas.',
  'failed-to-validate-quantity': 'Gagal melakukan validasi kuantitas.',
  'complete-pod/pop-not-completed': 'Mohon selesaikan POP terkait terlebih dahulu',

  'attachment/failed-to-get': 'Gagal mengambil lampiran aktivitas',
  'attachment/failed-to-save': 'Gagal menyimpan lampiran aktivitas',

  'delivery/failed-to-delete': 'Gagal mengeluarkan pengiriman.',
  'delivery/failed-to-unassigned-request':
    'Gagal mengeluarkan pengiriman. Pengiriman dari permintaan pengiriman tidak dapat dikeluarkan',

  'invalid/driver-already-used':
    'Gagal ubah status. Pengemudi telah terpakai pada pengiriman lain.',
  'invalid/driver-invalid-value':
    'Gagal ubah status. Pengemudi tidak ada di Data Master Pengemudi.',
  'invalid/vehicle-already-used':
    'Gagal ubah status. Kendaraan telah terpakai pada pengiriman lain.',
  'invalid/vehicle-invalid-value':
    'Gagal ubah status. Kendaraan tidak ada di Data Master Kendaraan.',
  'invalid/activities-must-be-completed':
    'Gagal ubah status. Selesaikan seluruh aktivitas terlebih dahulu.',
  'invalid/pickup-must-be-completed':
    'Gagal ubah status. Mohon selesaikan pengambilan terlebih dahulu.',
  'invalid/validation-started':
    'Gagal ubah kuantitas muatan. Tidak bisa ubah kuantitas muatan setelah validasi dimulai.',
  'invalid/invalid-fields': 'Gagal ubah status. Mohon periksa kembali data Anda.',
  'invalid/invalid-input-format': 'Gagal ubah status.',

  'invalid-input-format': 'Terdapat kesalahan format pada input anda.',
  'minimum-one-delivery': 'Gagal hapus. Minimal harus ada satu No. Pengiriman.',

  'failed-save-settings': 'Terdapat kesalahan menyimpan settings.',
  'failed-get-settings': 'Terdapat kesalahan mendapatkan data settings.',

  'is-from-vendor-request': 'Gagal hapus. Terdapat permintaan penugasan',
  'invalid/invalid-value': 'Gagal ubah status. Status tidak valid.',
  'delivery/cannot-unassign-from-fleet-task':
    'Gagal mengeluarkan pengiriman. Pengiriman telah ditugaskan pada penugasan lain.',
  'fleet-task-cannot-unassign-transit-delivery-order':
    'Gagal dibatalkan. Terdapat DO Transit pada penugasan ini.',
  'fleet-task-delivery-order-shipment-type-transit':
    'Penugasan dengan order transit tidak dapat di kirim ke vendor',
  'fleet-task-delivery-order-completed-transit':
    'Terdapat pengiriman yang telah ditugaskan hingga Tujuan terakhir',
  'fleet-task-last-and-new-transit-are-identical':
    'Lokasi transit tidak boleh sama dengan lokasi transit dari penugasan sebelumnya',
  'fleet-task-transit-address-are-identical':
    'Lokasi transit tidak boleh sama dengan lokasi asal dan Tujuan pengiriman',
  'fleet-task-delivery-order-origin-different-with-last-transit':
    'Origin transit tidak sama dengan lokasi transit penugasan sebelumnya',
  'delivery-order-vendor-request-invalid-shipment-type':
    'Permintaan pengiriman tidak boleh di tugaskan transit',
  'delivery-order-vendor-exists':
    'Gagal membuat penugasan. Terdapat pengiriman dengan tipe selain transit telah di plan ke vendor',
  'fleet-task-previous-activity-not-completed':
    'Gagal kirim ke vendor, pengiriman DO-xxx di penugasan FO-xxx belum selesai',
  'user-group-only-one-group-can-be-selected':
    'Tidak dapat dilanjutkan. Hanya satu grup pengguna yang dapat dipilih. dari kalimat diatas buatkan key sepert ini FLEET_TASK.FLEET_TASK_PREVIOUS_ACTIVITY_NOT_COMPLETED',
  'fleet-task-delivery-order-user-group-id-different':
    'Tidak dapat dilanjutkan. Hanya satu grup pengguna yang dapat dipilih.',
  'fleet-task-delivery-order-user-group-id-required':
    'Tidak dapat dilanjutkan. Terdapat pengiriman yang belum memiliki group pengguna.',
  'fleet-task-delivery-order-box-type-id-different':
    'Tidak dapat membuat penugasan, terdapat pengiriman dengan jenis box yang berbeda.',
  'fleet-task-box-type-not-found': 'Jenis Box tidak ditemukan.',
  'fleet-task-vehicle-box-type-id-different': ' Jenis Box kendaraan tidak sesuai dengan muatan.',
  'fleet-task-activity-invalid-status': 'Gagal melakukan pengiriman. Mohon selesaikan pengambilan terlebih dahulu.',
}

export default toastErrors
